// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login{
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 30px 
}

.login-container{
    max-width: max-content;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.login-left{
    max-width: 476px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
    background: rgba(73, 75, 75, 0.10);
    border-top-right-radius: 25px;
    padding: 40px 93px 40px 40px;
}

.content{
    color: #494B4B;
    margin-top: 165px;
}

.form-container{
    padding: 0 100px;
    max-width: 700px;
}

#kc-page-title{
    font-size: 42px;
    font-weight: 800;
    margin-bottom: 15px;
    color: #494B4B;
    margin-top: 0; 
}

.login-left .content {
    margin-top: 25px;
    color: #494B4B;
    flex: 1 1;
}

.login-left .content h2 {
    font-size: 42px;
    font-weight: 800;
    margin-bottom: 25px;
}

.login-left .content p {
    font-size: 32px;
    font-weight: 300;
    line-height: 1.2;
}

.login-left .content .banner {
    height: 100%;
}

.login-left .content .banner img {
    height: 100%;
    width: auto;
    object-fit: cover;
    max-width: 100%;
}

.login-btn{
    color:var(--secondary-900);
    font-weight: 600;
    margin-left: 12px;
    cursor: pointer;
}

.kc-form {
    padding-top: 40px;
    position: relative;
}

.kc-form-wrapper {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    color: #090826;
}

form label {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    color: #090826;
    display: block;
    font-weight: 600;
}

input[type="text"], input[type="email"], input[type="password"], input[type="date"], input[type="number"] {
    border-radius: 12px;
    border: 2px solid #E3E9F4;
    padding: 16px 24px;
    outline: none;
    margin-bottom: 15px;
    width: 425px 
}

.kc-form-buttons {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    padding: 22px 24px;
    border-radius: 52px;
    border: 3px solid rgba(255, 255, 255, 0.50);
    /* background: linear-gradient(99deg, var(--secondary-400) 7.06%, var(--secondary-500) 86.25%); */
    background-color: var(--secondary-800);
    box-shadow: 0px 14px 49px 0px var(--primary-opactiy-90);
    width: 160px;
    text-transform: capitalize;
}

.error-display{
    color: red;
    margin-top: 12px;
    font-weight: 600;
}

.error-page{
    color:red;
    font-weight:500;
    height:500px;
}

#disclaimer {
    margin-top: 40px;
    margin-bottom: 0;
    color: rgba(9, 8, 38, 0.60);
    /* color: #484b4b; */
    text-align: justify;
    line-height: 1.2;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
}

.sub-grp{
    border-radius: 14px;
    border: 2px solid var(--primary);
    background: var(--foundation-secondary-secondary-400, var(--primary));
    color: var(--text-high-emphasis, #090826);
    font-family: Inter;
    font-size: 0.8rem;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
}
.sub-grp:hover{
    background: var(--secondary-300);
    /* border: 2px solid var(--secondary-300); */
}

.content-body-collapse{
    margin-left: 5rem;
      
        margin-bottom: 1rem;
        margin-right: 1rem;
        transition: margin-left 0.4s ease;

}

.cancel-btn{
    
    border: 2px solid #E3E9F4;
    background: var(--foundation-secondary-secondary-400, #fff);
    border-radius: 11px;
    margin-right:5px;
    font-weight:600;
    font-size: 0.8rem;
    line-height: 120%;
}

.cancel-btn:hover{
    background: #ededed;
}

.modalPopup .spacing-div {margin-left: auto;}

.modalPopup{
    background:white;
    /* height: 48vh !important; */
    overflow-x: hidden;
max-height: 95vh;
min-width: auto;
        &.h-auto{
            height: auto!important;
            min-height: auto;
        }
.scrollable{
max-height: 65vh;
overflow-y: auto;
scroll-behavior: smooth;
height: -webkit-fill-available;
}
.title{
overflow: hidden;
color: var(--text-high-emphasis, #090826);
text-overflow: ellipsis;

/* Typography/Heading 3/Bold */
font-family: Inter;
font-size:1.8rem;
font-style: normal;
font-weight: 600;
line-height: 120%; /* 42px */
}
.title-text-small-color{
color: var(--text-high-emphasis, #090826); 
} 
}

.overlay{
    position: fixed;
    top:0;
    z-index: 20000000000!important;
    bottom: 0;
    left: 0;
    right:0;
    background: var(--foundation-neutral-neutral-900, #5c6065c1);
    width:100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .taskPopUp, .memberPopup, .modalPopup{
    background:white;
    /* height: 48vh !important; */
    overflow-x: hidden;
max-height: 95vh;
min-width: auto;
        &.h-auto{
            height: auto!important;
            min-height: auto;
        }
.scrollable{
max-height: 65vh;
overflow-y: auto;
scroll-behavior: smooth;
height: -webkit-fill-available;
}
.title{
overflow: hidden;
color: var(--text-high-emphasis, #090826);
text-overflow: ellipsis;

/* Typography/Heading 3/Bold */
font-family: Inter;
font-size:1.8rem;
font-style: normal;
font-weight: 600;
line-height: 120%; /* 42px */
}
.title-text-small-color{
color: var(--text-high-emphasis, #090826); 
} 
}
.border-right{
    border-right: 1px solid #E3E9F4;
}
.play-pause{
background: var(--foundation-secondary-secondary-50, var(--secondary-200));
    &.on {
        background: var(--foundation-secondary-secondary-500, var(--secondary-700));
        .play-pause-button{
            background: var(--foundation-secondary-secondary-50, var(--secondary-200));
            i {color: #000000;}
        }
    }
}
.play-pause-button{
    border-radius: 50px;
background: var(--foundation-secondary-secondary-500, var(--secondary-700));
box-shadow: 0px 4px 8px 0px rgba(92, 96, 101, 0.06);
}
.sum-title{
    color: var(--text-high-emphasis, #090826);

/* Typography/Body/Large/Bold */
font-family: Inter;
font-size: 0.9rem;
font-style: normal;
font-weight: 500;
line-height: 120%; /* 19.2px */
}
.uploadedFile{

border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
background: var(--foundation-neutral-neutral-50, #FCFCFE);
position: relative;
/* org */

.orgCreate{
border-radius: 24px;
background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);

/* modal page */
box-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.40);
min-height: 80vh;
min-width: auto;
height: 50vh !important;
overflow-x: hidden;
}



/* card */
box-shadow: 10px 14px 14px 0px rgba(92, 96, 101, 0.08);
.filename{
color: var(--text-high-emphasis, #090826);

/* Typography/Body/Default/Regular */
font-family: Inter;
font-size: 0.8rem;
font-style: normal;
font-weight: 400;
line-height: 130%; /* 18.2px */
}
.fileDetail{
color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60));

/* Typography/Body/Extra Small/Regular */
font-family: Inter;
font-size: 10px;
font-style: normal;
font-weight: 400;
line-height: 120%; /* 12px */
}
.document-svg{
box-shadow: 2px 4px 10px 0px rgba(92, 96, 101, 0.24);
}
.pdf{
border-radius: 1px;
background: var(--foundation-red-red-500, #FF6969);
color: #FFF;
text-align: center;
font-family: Inter;
font-size: 8px;
font-style: normal;
font-weight: 600;
line-height: normal;
}
.default{
border-radius: 1px;
background: var(--foundation-red-red-500, #48792f);
color: #FFF;
text-align: center;
font-family: Inter;
font-size: 8px;
font-style: normal;
font-weight: 600;
line-height: normal;  
}
.png{
border-radius: 1px;
background: var(--foundation-dark-blue-dark-blue-500, #6C9BF6);
color: #FFF;
text-align: center;
font-family: Inter;
font-size: 8px;
font-style: normal;
font-weight: 600;
line-height: normal;  
}
.svg{
border-radius: 1px;
background: var(--foundation-red-red-500, #f09409);
color: #FFF;
text-align: center;
font-family: Inter;
font-size: 8px;
font-style: normal;
font-weight: 600;
line-height: normal;
}

}
}

.delete-obj{
    background: var(--Error-error-button-enabled, #FF6969);
    box-shadow: 0px 10px 31px 0px #FF696966;
    font-weight: 600;
}

.cancel-btn-popup{
    
    border: 2px solid #E3E9F4;
    background: var(--foundation-secondary-secondary-400, #fff);
    border-radius: 11px;
    margin-right:5px;
    font-weight:600;
}

.cancel-btn-popup:hover{
    background: #ededed;
}

.signup-loader {
    border: 4px solid rgba(255, 255, 255, 0.3); /* Light grey background */
    border-radius: 50%;
    border-top: 4px solid white; /* White color for the loader */
    width: 20px;
    height: 20px;
    animation: spin 2s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .kc-form-buttons.disabled {
    opacity: 0.6; /* Decrease opacity for disabled state */
    pointer-events: none; /* Disable pointer events */
  }

  .error-text-msg{
    font-size: 13px;
      color: #FF6969;
      margin-bottom: 15px;
      margin-top: -5px;
  }

  .error-validaion{
    border: 2px solid var(--red-300) !important;
    box-shadow: 0 0 5px 2px var(--red-200);
  }

  .password-input {
    border-radius: 12px;
    border: 2px solid #E3E9F4;
    padding: 16px 24px;
    outline: none;
    margin-bottom: 15px;
    width: 425px;
    padding-right: 10px; /* Adjust padding to make space for the eye icon */
  }
  
  .relative {
    position: relative;
  }
  
  .absolute {
    position: absolute;
  }
  
  .inset-y-15 {
    top: -15px;
    bottom: 0;
  }
  
  .right-80 {
    right: 80px;
  }
  
  .pr-3 {
    padding-right: 12px;
  }

  .decline-loader{
    border: 4px solid var(--primary);
    border-radius: 50%;
    border-top: 4px solid white;
    width: 20px;
    height: 20px;
    animation: spin 2s linear infinite;
  }
  
  .flex {
    display: flex;
  }
  
  .items-center {
    align-items: center;
  }
  
  .cursor-pointer {
    cursor: pointer;
  }

.validation-check {list-style: none outside; padding-left: 0;}
.validation-check li:before {margin-right: 5px; width: 12px; display: inline-block; vertical-align: middle;}
.validation-check li.yes:before {content: "\\2713"; color: #2bd948;}
.validation-check li.no:before {content: "\\2715"; color: #ff0000;}`, "",{"version":3,"sources":["webpack://./src/kz-usersignup/Signup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,iGAAiG;IACjG,sCAAsC;IACtC,uDAAuD;IACvD,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,qEAAqE;IACrE,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gCAAgC;IAChC,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;;QAEb,mBAAmB;QACnB,kBAAkB;QAClB,iCAAiC;;AAEzC;;AAEA;;IAEI,yBAAyB;IACzB,2DAA2D;IAC3D,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0BAA0B,iBAAiB,CAAC;;AAE5C;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;AACtB,gBAAgB;AAChB,eAAe;QACP;YACI,sBAAsB;YACtB,gBAAgB;QACpB;AACR;AACA,gBAAgB;AAChB,gBAAgB;AAChB,uBAAuB;AACvB,8BAA8B;AAC9B;AACA;AACA,gBAAgB;AAChB,yCAAyC;AACzC,uBAAuB;;AAEvB,8BAA8B;AAC9B,kBAAkB;AAClB,gBAAgB;AAChB,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,SAAS;AAC5B;AACA;AACA,yCAAyC;AACzC;AACA;;AAEA;IACI,eAAe;IACf,KAAK;IACL,8BAA8B;IAC9B,SAAS;IACT,OAAO;IACP,OAAO;IACP,4DAA4D;IAC5D,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;IACA,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;AACtB,gBAAgB;AAChB,eAAe;QACP;YACI,sBAAsB;YACtB,gBAAgB;QACpB;AACR;AACA,gBAAgB;AAChB,gBAAgB;AAChB,uBAAuB;AACvB,8BAA8B;AAC9B;AACA;AACA,gBAAgB;AAChB,yCAAyC;AACzC,uBAAuB;;AAEvB,8BAA8B;AAC9B,kBAAkB;AAClB,gBAAgB;AAChB,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,SAAS;AAC5B;AACA;AACA,yCAAyC;AACzC;AACA;AACA;IACI,+BAA+B;AACnC;AACA;AACA,0EAA0E;IACtE;QACI,2EAA2E;QAC3E;YACI,0EAA0E;YAC1E,GAAG,cAAc,CAAC;QACtB;IACJ;AACJ;AACA;IACI,mBAAmB;AACvB,2EAA2E;AAC3E,mDAAmD;AACnD;AACA;IACI,yCAAyC;;AAE7C,+BAA+B;AAC/B,kBAAkB;AAClB,iBAAiB;AACjB,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,WAAW;AAC9B;AACA;;AAEA,gEAAgE;AAChE,yDAAyD;AACzD,kBAAkB;AAClB,QAAQ;;AAER;AACA,mBAAmB;AACnB,gFAAgF;;AAEhF,eAAe;AACf,sDAAsD;AACtD,gBAAgB;AAChB,eAAe;AACf,uBAAuB;AACvB,kBAAkB;AAClB;;;;AAIA,SAAS;AACT,sDAAsD;AACtD;AACA,yCAAyC;;AAEzC,oCAAoC;AACpC,kBAAkB;AAClB,iBAAiB;AACjB,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,WAAW;AAC9B;AACA;AACA,wDAAwD;;AAExD,wCAAwC;AACxC,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,SAAS;AAC5B;AACA;AACA,oDAAoD;AACpD;AACA;AACA,kBAAkB;AAClB,kDAAkD;AAClD,WAAW;AACX,kBAAkB;AAClB,kBAAkB;AAClB,cAAc;AACd,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;AACA,kBAAkB;AAClB,kDAAkD;AAClD,WAAW;AACX,kBAAkB;AAClB,kBAAkB;AAClB,cAAc;AACd,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;AACA,kBAAkB;AAClB,8DAA8D;AAC9D,WAAW;AACX,kBAAkB;AAClB,kBAAkB;AAClB,cAAc;AACd,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;AACA,kBAAkB;AAClB,kDAAkD;AAClD,WAAW;AACX,kBAAkB;AAClB,kBAAkB;AAClB,cAAc;AACd,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;;AAEA;AACA;;AAEA;IACI,sDAAsD;IACtD,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,2DAA2D;IAC3D,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0CAA0C,EAAE,0BAA0B;IACtE,kBAAkB;IAClB,2BAA2B,EAAE,+BAA+B;IAC5D,WAAW;IACX,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA;IACE,YAAY,EAAE,wCAAwC;IACtD,oBAAoB,EAAE,2BAA2B;EACnD;;EAEA;IACE,eAAe;MACb,cAAc;MACd,mBAAmB;MACnB,gBAAgB;EACpB;;EAEA;IACE,2CAA2C;IAC3C,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB,EAAE,kDAAkD;EACzE;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;AAEF,mBAAmB,wBAAwB,EAAE,eAAe,CAAC;AAC7D,6BAA6B,iBAAiB,EAAE,WAAW,EAAE,qBAAqB,EAAE,sBAAsB,CAAC;AAC3G,iCAAiC,gBAAgB,EAAE,cAAc,CAAC;AAClE,gCAAgC,gBAAgB,EAAE,cAAc,CAAC","sourcesContent":[".login{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    padding: 30px \n}\n\n.login-container{\n    max-width: max-content;\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n}\n\n.login-left{\n    max-width: 476px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    position: relative;\n    background: rgba(73, 75, 75, 0.10);\n    border-top-right-radius: 25px;\n    padding: 40px 93px 40px 40px;\n}\n\n.content{\n    color: #494B4B;\n    margin-top: 165px;\n}\n\n.form-container{\n    padding: 0 100px;\n    max-width: 700px;\n}\n\n#kc-page-title{\n    font-size: 42px;\n    font-weight: 800;\n    margin-bottom: 15px;\n    color: #494B4B;\n    margin-top: 0; \n}\n\n.login-left .content {\n    margin-top: 25px;\n    color: #494B4B;\n    flex: 1;\n}\n\n.login-left .content h2 {\n    font-size: 42px;\n    font-weight: 800;\n    margin-bottom: 25px;\n}\n\n.login-left .content p {\n    font-size: 32px;\n    font-weight: 300;\n    line-height: 1.2;\n}\n\n.login-left .content .banner {\n    height: 100%;\n}\n\n.login-left .content .banner img {\n    height: 100%;\n    width: auto;\n    object-fit: cover;\n    max-width: 100%;\n}\n\n.login-btn{\n    color:var(--secondary-900);\n    font-weight: 600;\n    margin-left: 12px;\n    cursor: pointer;\n}\n\n.kc-form {\n    padding-top: 40px;\n    position: relative;\n}\n\n.kc-form-wrapper {\n    font-family: 'Inter', sans-serif;\n    font-size: 16px;\n    color: #090826;\n}\n\nform label {\n    font-family: 'Inter', sans-serif;\n    font-size: 16px;\n    color: #090826;\n    display: block;\n    font-weight: 600;\n}\n\ninput[type=\"text\"], input[type=\"email\"], input[type=\"password\"], input[type=\"date\"], input[type=\"number\"] {\n    border-radius: 12px;\n    border: 2px solid #E3E9F4;\n    padding: 16px 24px;\n    outline: none;\n    margin-bottom: 15px;\n    width: 425px \n}\n\n.kc-form-buttons {\n    font-size: 16px;\n    font-weight: 600;\n    color: #ffffff;\n    padding: 22px 24px;\n    border-radius: 52px;\n    border: 3px solid rgba(255, 255, 255, 0.50);\n    /* background: linear-gradient(99deg, var(--secondary-400) 7.06%, var(--secondary-500) 86.25%); */\n    background-color: var(--secondary-800);\n    box-shadow: 0px 14px 49px 0px var(--primary-opactiy-90);\n    width: 160px;\n    text-transform: capitalize;\n}\n\n.error-display{\n    color: red;\n    margin-top: 12px;\n    font-weight: 600;\n}\n\n.error-page{\n    color:red;\n    font-weight:500;\n    height:500px;\n}\n\n#disclaimer {\n    margin-top: 40px;\n    margin-bottom: 0;\n    color: rgba(9, 8, 38, 0.60);\n    /* color: #484b4b; */\n    text-align: justify;\n    line-height: 1.2;\n    font-family: 'Inter', sans-serif;\n    font-size: 12px;\n}\n\n.sub-grp{\n    border-radius: 14px;\n    border: 2px solid var(--primary);\n    background: var(--foundation-secondary-secondary-400, var(--primary));\n    color: var(--text-high-emphasis, #090826);\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n}\n.sub-grp:hover{\n    background: var(--secondary-300);\n    /* border: 2px solid var(--secondary-300); */\n}\n\n.content-body-collapse{\n    margin-left: 5rem;\n      \n        margin-bottom: 1rem;\n        margin-right: 1rem;\n        transition: margin-left 0.4s ease;\n\n}\n\n.cancel-btn{\n    \n    border: 2px solid #E3E9F4;\n    background: var(--foundation-secondary-secondary-400, #fff);\n    border-radius: 11px;\n    margin-right:5px;\n    font-weight:600;\n    font-size: 0.8rem;\n    line-height: 120%;\n}\n\n.cancel-btn:hover{\n    background: #ededed;\n}\n\n.modalPopup .spacing-div {margin-left: auto;}\n\n.modalPopup{\n    background:white;\n    /* height: 48vh !important; */\n    overflow-x: hidden;\nmax-height: 95vh;\nmin-width: auto;\n        &.h-auto{\n            height: auto!important;\n            min-height: auto;\n        }\n.scrollable{\nmax-height: 65vh;\noverflow-y: auto;\nscroll-behavior: smooth;\nheight: -webkit-fill-available;\n}\n.title{\noverflow: hidden;\ncolor: var(--text-high-emphasis, #090826);\ntext-overflow: ellipsis;\n\n/* Typography/Heading 3/Bold */\nfont-family: Inter;\nfont-size:1.8rem;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 42px */\n}\n.title-text-small-color{\ncolor: var(--text-high-emphasis, #090826); \n} \n}\n\n.overlay{\n    position: fixed;\n    top:0;\n    z-index: 20000000000!important;\n    bottom: 0;\n    left: 0;\n    right:0;\n    background: var(--foundation-neutral-neutral-900, #5c6065c1);\n    width:100vw;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .taskPopUp, .memberPopup, .modalPopup{\n    background:white;\n    /* height: 48vh !important; */\n    overflow-x: hidden;\nmax-height: 95vh;\nmin-width: auto;\n        &.h-auto{\n            height: auto!important;\n            min-height: auto;\n        }\n.scrollable{\nmax-height: 65vh;\noverflow-y: auto;\nscroll-behavior: smooth;\nheight: -webkit-fill-available;\n}\n.title{\noverflow: hidden;\ncolor: var(--text-high-emphasis, #090826);\ntext-overflow: ellipsis;\n\n/* Typography/Heading 3/Bold */\nfont-family: Inter;\nfont-size:1.8rem;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 42px */\n}\n.title-text-small-color{\ncolor: var(--text-high-emphasis, #090826); \n} \n}\n.border-right{\n    border-right: 1px solid #E3E9F4;\n}\n.play-pause{\nbackground: var(--foundation-secondary-secondary-50, var(--secondary-200));\n    &.on {\n        background: var(--foundation-secondary-secondary-500, var(--secondary-700));\n        .play-pause-button{\n            background: var(--foundation-secondary-secondary-50, var(--secondary-200));\n            i {color: #000000;}\n        }\n    }\n}\n.play-pause-button{\n    border-radius: 50px;\nbackground: var(--foundation-secondary-secondary-500, var(--secondary-700));\nbox-shadow: 0px 4px 8px 0px rgba(92, 96, 101, 0.06);\n}\n.sum-title{\n    color: var(--text-high-emphasis, #090826);\n\n/* Typography/Body/Large/Bold */\nfont-family: Inter;\nfont-size: 0.9rem;\nfont-style: normal;\nfont-weight: 500;\nline-height: 120%; /* 19.2px */\n}\n.uploadedFile{\n\nborder: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);\nbackground: var(--foundation-neutral-neutral-50, #FCFCFE);\nposition: relative;\n/* org */\n\n.orgCreate{\nborder-radius: 24px;\nbackground: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);\n\n/* modal page */\nbox-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.40);\nmin-height: 80vh;\nmin-width: auto;\nheight: 50vh !important;\noverflow-x: hidden;\n}\n\n\n\n/* card */\nbox-shadow: 10px 14px 14px 0px rgba(92, 96, 101, 0.08);\n.filename{\ncolor: var(--text-high-emphasis, #090826);\n\n/* Typography/Body/Default/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 130%; /* 18.2px */\n}\n.fileDetail{\ncolor: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60));\n\n/* Typography/Body/Extra Small/Regular */\nfont-family: Inter;\nfont-size: 10px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 12px */\n}\n.document-svg{\nbox-shadow: 2px 4px 10px 0px rgba(92, 96, 101, 0.24);\n}\n.pdf{\nborder-radius: 1px;\nbackground: var(--foundation-red-red-500, #FF6969);\ncolor: #FFF;\ntext-align: center;\nfont-family: Inter;\nfont-size: 8px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n.default{\nborder-radius: 1px;\nbackground: var(--foundation-red-red-500, #48792f);\ncolor: #FFF;\ntext-align: center;\nfont-family: Inter;\nfont-size: 8px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;  \n}\n.png{\nborder-radius: 1px;\nbackground: var(--foundation-dark-blue-dark-blue-500, #6C9BF6);\ncolor: #FFF;\ntext-align: center;\nfont-family: Inter;\nfont-size: 8px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;  \n}\n.svg{\nborder-radius: 1px;\nbackground: var(--foundation-red-red-500, #f09409);\ncolor: #FFF;\ntext-align: center;\nfont-family: Inter;\nfont-size: 8px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n\n}\n}\n\n.delete-obj{\n    background: var(--Error-error-button-enabled, #FF6969);\n    box-shadow: 0px 10px 31px 0px #FF696966;\n    font-weight: 600;\n}\n\n.cancel-btn-popup{\n    \n    border: 2px solid #E3E9F4;\n    background: var(--foundation-secondary-secondary-400, #fff);\n    border-radius: 11px;\n    margin-right:5px;\n    font-weight:600;\n}\n\n.cancel-btn-popup:hover{\n    background: #ededed;\n}\n\n.signup-loader {\n    border: 4px solid rgba(255, 255, 255, 0.3); /* Light grey background */\n    border-radius: 50%;\n    border-top: 4px solid white; /* White color for the loader */\n    width: 20px;\n    height: 20px;\n    animation: spin 2s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n\n  .kc-form-buttons.disabled {\n    opacity: 0.6; /* Decrease opacity for disabled state */\n    pointer-events: none; /* Disable pointer events */\n  }\n\n  .error-text-msg{\n    font-size: 13px;\n      color: #FF6969;\n      margin-bottom: 15px;\n      margin-top: -5px;\n  }\n\n  .error-validaion{\n    border: 2px solid var(--red-300) !important;\n    box-shadow: 0 0 5px 2px var(--red-200);\n  }\n\n  .password-input {\n    border-radius: 12px;\n    border: 2px solid #E3E9F4;\n    padding: 16px 24px;\n    outline: none;\n    margin-bottom: 15px;\n    width: 425px;\n    padding-right: 10px; /* Adjust padding to make space for the eye icon */\n  }\n  \n  .relative {\n    position: relative;\n  }\n  \n  .absolute {\n    position: absolute;\n  }\n  \n  .inset-y-15 {\n    top: -15px;\n    bottom: 0;\n  }\n  \n  .right-80 {\n    right: 80px;\n  }\n  \n  .pr-3 {\n    padding-right: 12px;\n  }\n\n  .decline-loader{\n    border: 4px solid var(--primary);\n    border-radius: 50%;\n    border-top: 4px solid white;\n    width: 20px;\n    height: 20px;\n    animation: spin 2s linear infinite;\n  }\n  \n  .flex {\n    display: flex;\n  }\n  \n  .items-center {\n    align-items: center;\n  }\n  \n  .cursor-pointer {\n    cursor: pointer;\n  }\n\n.validation-check {list-style: none outside; padding-left: 0;}\n.validation-check li:before {margin-right: 5px; width: 12px; display: inline-block; vertical-align: middle;}\n.validation-check li.yes:before {content: \"\\2713\"; color: #2bd948;}\n.validation-check li.no:before {content: \"\\2715\"; color: #ff0000;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
